import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom-v5-compat';

import { DateTimeDisplay } from 'ui-components/components/date-time-display/date-time-display';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { GridHeaderWithOverflow } from '../../../../components/grid-header/grid-header-with-overflow';
import style from '../../../grid-page.module.less';
import { useExternalInventoryConnectionsContext } from '../../external-inventory-connections-context';
import messages from '../../messages';

/**
 * External Inventory Grid Header Component
 * Displays the header with inventory source name and last updated timestamp
 * @returns {React.ReactElement} The grid header component
 */
export const ExternalInventoryGridHeader = () => {
  const { externalInventorySourceId } = useParams();
  const { connectionSources } = useExternalInventoryConnectionsContext();

  const { inventoryName, lastUpdated } = useMemo(() => {
    const inventory = connectionSources?.find((w) => w.connectionId === externalInventorySourceId);
    return {
      inventoryName: inventory ? inventory.name : <FormattedMessage {...messages.allExternalInventory} />,
      lastUpdated: inventory?.updatedAt ?? null,
    };
  }, [connectionSources, externalInventorySourceId]);

  const view = {
    id: 'externalInventoryGridHeader',
    label: inventoryName,
    buttons: [],
  };

  return (
    <FlexRow className={style['grid-header-with-time-stamp']}>
      <GridHeaderWithOverflow ignoreCustomOverflow view={view} />
      {lastUpdated ? (
        <Text
          className={style['time-stamp']}
          element='div'
          textType={TextType.Paragraph}
          value={
            <FlexRow>
              <FormattedMessage {...messages.lastSynced} />
              <DateTimeDisplay includeTimezone utcTimestamp={lastUpdated} />
            </FlexRow>
          }
        />
      ) : null}
    </FlexRow>
  );
};
